import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import { bool, func, object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { I18n } from 'utils/i18n';

const PARAM_TYPES = ['string', 'number', 'boolean', 'object', 'array'];

const ParameterDialog = ({ open, title, initial, onClose, onSave }) => {
  const [draft, setDraft] = useState(initial || {});

  useEffect(() => {
    if (open) {
      setDraft(initial || { name: '', type: 'string', required: false, description: '' });
    }
  }, [open, initial]);

  const handleSave = () => {
    if (!draft.name?.trim()) return;
    onSave({
      ...draft,
      name: draft.name.trim(),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 0.5 }}>
          <TextField
            label={I18n.t('AgenticChatFlow.ParamName')}
            value={draft.name || ''}
            onChange={e => setDraft({ ...draft, name: e.target.value })}
            size="small"
            fullWidth
            autoFocus
          />
          <TextField
            select
            label={I18n.t('AgenticChatFlow.ParamType')}
            value={draft.type || 'string'}
            onChange={e => setDraft({ ...draft, type: e.target.value })}
            size="small"
            fullWidth
          >
            {PARAM_TYPES.map(t => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label={I18n.t('AgenticChatFlow.ParamDescription')}
            value={draft.description || ''}
            onChange={e => setDraft({ ...draft, description: e.target.value })}
            size="small"
            fullWidth
            multiline
            minRows={2}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={!!draft.required}
                onChange={e => setDraft({ ...draft, required: e.target.checked })}
              />
            }
            label={I18n.t('AgenticChatFlow.ParamRequired')}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          {I18n.t('AgenticChatFlow.Cancel')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleSave}
          disabled={!draft.name?.trim()}
        >
          {I18n.t('AgenticChatFlow.Save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ParameterDialog.propTypes = {
  open: bool,
  title: string.isRequired,
  initial: object,
  onClose: func.isRequired,
  onSave: func.isRequired,
};

export default ParameterDialog;
